import { Link, Panel, PanelType, Stack, Text, getTheme } from '@fluentui/react';
import { useMemo } from 'react';
import { buildHistoryVersions } from './metadataHistory';

interface MetadataHistoryPanelProps {
  isOpen: boolean;
  entity: string;
  name: string;
  latestVersion: number;
  currentVersion: number;
  onSelect: (version: number) => void;
  onDismiss: () => void;
}

const MetadataHistoryPanel = ({
  isOpen,
  entity,
  name,
  latestVersion,
  currentVersion,
  onSelect,
  onDismiss,
}: MetadataHistoryPanelProps) => {
  const theme = getTheme();
  const versions = useMemo(
    () => [latestVersion, ...buildHistoryVersions(latestVersion)],
    [latestVersion]
  );

  return (
    <Panel
      isOpen={isOpen}
      onDismiss={onDismiss}
      type={PanelType.medium}
      headerText="History"
      closeButtonAriaLabel="Close"
      isLightDismiss
    >
      <Stack tokens={{ childrenGap: 12 }}>
        <Text variant="medium">
          {entity} | {name}
        </Text>

        <Stack tokens={{ childrenGap: 6 }}>
          {versions.map((v) => {
            const isActive = v === currentVersion;
            const isLatest = v === latestVersion;
            return (
              <Stack
                key={v}
                horizontal
                verticalAlign="center"
                tokens={{ childrenGap: 8 }}
              >
                <Link
                  onClick={isActive ? undefined : () => onSelect(v)}
                  disabled={isActive}
                  aria-current={isActive ? 'true' : undefined}
                >
                  Version {v}
                </Link>
                {isLatest && (
                  <Text
                    variant="small"
                    style={{
                      background: theme.palette.themeLighter,
                      color: theme.palette.themePrimary,
                      padding: '2px 6px',
                      borderRadius: 4,
                    }}
                  >
                    Latest
                  </Text>
                )}
                {isActive && <Text variant="small">(viewing)</Text>}
              </Stack>
            );
          })}
        </Stack>
      </Stack>
    </Panel>
  );
};

export default MetadataHistoryPanel;
